
import {  sendTripOnEdiRequest } from '../../requests';

export default async function sendTripOnEdi({ state, commit , dispatch }) {
	let response = await sendTripOnEdiRequest(state.tripSearch.tripDetails.id);
	if (response.tripDetails) {
		dispatch('tripSearch/fetchTrips');
		commit('setTrip', response.tripDetails);
	}

}